import { render, staticRenderFns } from "./addRecommendTag.vue?vue&type=template&id=0a4c7680&"
import script from "./addRecommendTag.vue?vue&type=script&lang=js&"
export * from "./addRecommendTag.vue?vue&type=script&lang=js&"
import style0 from "./addRecommendTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports